export const API_BASE_AUTH = "/api/auth/";
export const API_BASE_MM = "/api/mm/";
export const API_BASE_REPORTING = "/api/reporting/";
export const API_BASE_ADMIN = "/api/admin/";
